import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { ContentLayout } from '@nohara-dxdev/react-core';

import NotFoundRoute from '../not-found';

const OrgDashboardRoute = () => {
  const { t } = useTranslation();
  const { orgId } = useParams<{ orgId: string }>();

  if (!orgId) {
    return <NotFoundRoute />;
  }

  return (
    <ContentLayout title={t('orgDashboard.title')}>Home Screen. Add tiles here.</ContentLayout>
  );
};

export default OrgDashboardRoute;
